var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/yiyao/%E9%A2%97%E7%B2%92%E8%A2%8B%E8%A3%85%E7%9B%92%E6%B5%81%E6%B0%B4%E7%BA%BF.mp4",
                    'title':"视觉引导双联药包装盒",
                    'lable':"由包装机包装好的颗粒袋经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并提供OK/ NG指令及定点位置给到机器人，再由机器人进行高速追踪抓取、放置入槽后，由装盒机进行全自动装盒，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度可达到120次/min"
                        },
                        {
                            'icon':"/static/case/jd.png",
                            'title':"识别精度为±2mm"
                        }
                    ]
                }
            ]
        },
        {
            'name':"并联机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/yiyao/BFS%E5%88%86%E6%8B%A3%E8%A3%85%E7%9B%92.mp4",
                    'title':"BFS分拣装盒",
                    'lable':"由包装机包装好的BFS经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并提供OK/ NG指令及定点位置给到机器人，再由机器人进行高速追踪抓取、放置入槽，由装盒机进行全自动装盒，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度80瓶/分钟/台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升100%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期18个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"灌装包装出料"
                        },
                        {
                            'icon':"/static/case/xcjc.png",
                            'title':"视觉瑕疵检测并定位"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动放过渡槽"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"推入装盒机"
                        }

                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/yiyao/%E9%A2%97%E7%B2%92%E8%A2%8B%E8%A3%85%E7%9B%92%E6%B5%81%E6%B0%B4%E7%BA%BF.mp4",
                    'title':"颗粒袋装盒流水线",
                    'lable':"由包装机包装好的颗粒袋经传送带输送至工业相机下方，通过视觉系统定位、识别、检测来料并提供OK/ NG指令及定点位置给到机器人，再由机器人进行高速追踪抓取、放置入槽后，由装盒机进行全自动装盒，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度120袋/分钟/台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工2人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升99%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期24个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"灌装包装出料"
                        },
                        {
                            'icon':"/static/case/xcjc.png",
                            'title':"视觉瑕疵检测并定位"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人随动放过渡槽"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"推入装盒机"
                        }

                    ]
                },
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/yiyao/%E8%A5%BF%E6%9E%97%E7%93%B6%E8%A3%85%E7%9B%92%E5%8D%95%E5%85%83%20.mp4",
                    'title':"西林瓶装盒单元",
                    'lable':"物料经传送带输送至工业相机下方，通过传感器系统定位传送信号至机器人，再由机器人进行高速追踪抓取、放置入槽，自动化工序完成。",
                    'list':[
                        {
                            'icon':"/static/case/sd.png",
                            'title':"速度60盒/分钟/台"
                        },
                        {
                            'icon':"/static/case/rg.png",
                            'title':"单台去人工3人"
                        },
                        {
                            'icon':"/static/case/ts.png",
                            'title':"效率提升99.8%"
                        }
                        ,
                        {
                            'icon':"/static/case/tzhbzq.png",
                            'title':"投资回报周期15个月"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/ll.png",
                            'title':"西林瓶整理出料"
                        },
                        {
                            'icon':"/static/case/cgqjc.png",
                            'title':"通过传感器检测"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"机器人抓取"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"放入料托"
                        }
                        ,
                        {
                            'icon':"/static/case/fz.png",
                            'title':"推入装盒"
                        }

                    ]
                }
            ]
        },
       
    ],
    name:"医药",
    title:"solutions",
    subtitle:"医药行业应用案例",
    subinfo:"我们的应用案例包括为医药行业提供药品包装、药品搬运、医疗设备制造、医疗影像相关服务，助力医药行业发展。",
}

export default {
    industryInfo
  };    


// WEBPACK FOOTER //
// ./src/data/industryInfo/6.js